import { Dashboard } from "@/model/data/dashboard/Dashboard";
import { MutationTree } from "vuex";
import { DashboardState } from "./state";

export const SET_DASHBOARD_LIST = "SET_DASHBOARD_LIST";
export const SET_EDIT_MODE_ENABLED = "SET_EDIT_MODE_ENABLED";

export default {
    [SET_DASHBOARD_LIST](state: DashboardState, dashboards: Dashboard[]) {
        state.dashboards = dashboards;
    },
    [SET_EDIT_MODE_ENABLED](state: DashboardState, enabled: Boolean) {
        state.editModeEnabled = enabled;
    },
} as MutationTree<DashboardState>;
